import { Box, styled } from "@mui/material";

export const AttachmentModalContent = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-items: flex-start;
  width: 100%;
`;

export const AttachmentModalDataGrid = styled(Box)`
  overflow: hidden;
  flex: 1;
  display: flex;
  width: 100%;
`;
